module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab143-78751dce094fb97c000709ad7c8cc77f.jpg";